<template>
  <div>
    <div class="clear">
      <self-back v-if="statement_id" :pageHeaderList="[{'name':'结算单申请',path:'/incomeStatement'},{'name':'结算单申请详情'}]" style="float:left"></self-back>
      <self-back v-else :pageHeaderList="[{'name':'结算单申请',path:'/incomeStatement'},{'name':'结算单申请详情'}]" style="float:left"></self-back>
      <div style="display:inline-block;float:right;margin-top:10px">
        <el-button type='primary' size='mini' @click="print_png_DOM">导出<span style="font-size:12px">（图片格式）</span></el-button>
        <el-button type='primary' size='mini' @click="printDOM">导出<span style="font-size:12px">（PDF格式）</span><i v-show="exportFlag" class="el-icon-loading"></i></el-button>
        <el-button type='primary' size='mini' v-if="type == 2 && dataInfo.account && (!statement_id || dataInfo.account.verify_status == 0 || dataInfo.account.verify_status == 3 || dataInfo.account.verify_status == 5)" @click="openBatchEditDialog">编辑下单金额</el-button>
      </div>
    </div>
    <div class="statementToast" v-loading='loading'>
      <div v-if="dataInfo.account&&dataInfo.order">
        <div ref="printStatement2" id="ImageExportDom">
          <img src="@/assets/img/voided.png" v-if="dataInfo.account.is_voided==1&&enable_apply!=1" class="voided" alt="">
          <div class="mainTitle">
            <h3 v-if="type==2">MCN机构服务费结算单</h3>
            <h3 v-else>{{dataInfo.account.party_a_name}}结算单</h3>
            <div class="bothSides">甲方：{{dataInfo.account.party_a_name}}</div>
            <div class="bothSides">乙方：{{dataInfo.account.name}}</div>
            <div class="bothSides statementsID" v-if="dataInfo.account.statements_id">序列号：{{dataInfo.account.statements_id}}</div>
            <div class="bothSides statementsID" style="top:100px" v-if="statement_id">{{dataInfo.account.verify_status == 0 ?'已保存':dataInfo.account.verify_status == 1?'商务待审核':dataInfo.account.verify_status == 2?'财务待审核':dataInfo.account.verify_status == 3?'商务驳回':dataInfo.account.verify_status == 4?'财务审核通过':dataInfo.account.verify_status == 5?'财务驳回':''}}</div>
            <div class="bothSides statementsID" style="top:75px" v-if="dataInfo&&dataInfo.account&&dataInfo.account.applicant_time">申请时间：{{dataInfo.account.applicant_time}}</div>
          </div>
          <game-statement :dataInfo="dataInfo" v-if="type==5"></game-statement>
          <cpa-statement :dataInfo="dataInfo" v-if="type==4"></cpa-statement>
          <mcn-statement :dataInfo="dataInfo" v-if="type==2" :statement_id='statement_id' ref="mcnStatementRef"></mcn-statement>
          <pdd-statement :dataInfo="dataInfo" v-if="type==6"></pdd-statement>
          <div class="bothSidesBox clear">
            <div class="aParty">
              <div class="title">甲方银行账号信息如下：</div>
              <div class="infoItem">
                <label>名称：</label>
                <div class="inputDiv">{{dataInfo.account.party_a_name}}</div>
              </div>
              <div class="infoItem">
                <label>税号：</label>
                <div class="inputDiv">{{dataInfo.account.party_a_ein}}</div>
              </div>
              <div class="infoItem">
                <label style="vertical-align: top;">地址/电话：</label>
                <div class="inputDiv">{{dataInfo.account.party_a_address}}</div>
              </div>
              <div class="infoItem">
                <label style="vertical-align: top;">银行/账号：</label>
                <div class="inputDiv">{{dataInfo.account.party_a_account}}</div>
              </div>
              <div class="infoItem">
                <label style="width:100%">甲方：{{dataInfo.account.party_a_name}}</label>
              </div>
              <div class="infoItem">
                <label>签字盖章：</label>
              </div>
              <div class="infoItem">
                <label>联系人：</label>
                <div class="inputDiv" v-if="editFlag">{{dataInfo.account.party_a_contact}}</div>
                <el-input class="input" v-else v-model="dataInfo.account.party_a_contact" size='mini' placeholder="请输入联系人"></el-input>
              </div>
              <div class="infoItem">
                <label>联系电话：</label>
                <div class="inputDiv" v-if="editFlag">{{dataInfo.account.party_a_phone}}</div>
                <el-input class="input" v-else v-model="dataInfo.account.party_a_phone" size='mini' placeholder="请输入联系电话"></el-input>
              </div>
              <div class="infoItem">
                <label>日期：</label>
                <div class="inputDiv" v-if="editFlag">{{dataInfo.account.party_a_add_date}}</div>
                <el-date-picker v-else style="width:160px" v-model="party_a_add_date" type="date" size="mini" value-format="yyyy-MM-dd" placeholder="日期">
                </el-date-picker>
              </div>
            </div>
            <div class="aParty">
              <div class="title">乙方银行账号信息如下：</div>
              <div class="infoItem">
                <label>账号名称：</label>
                <div class="inputDiv">{{dataInfo.account.name}}</div>
              </div>
              <div class="infoItem">
                <label>开户银行：</label>
                <div class="inputDiv" v-if="editFlag">{{dataInfo.account.bank}}</div>
                <el-select class="input" v-else v-model="dataInfo.account.bank" size='mini' filterable placeholder="开户银行" @change="(val)=>{dataInfo.account.account = partyBAccountList.filter((v)=>{return v.bank == val})[0].account}">
                  <el-option v-for="(item,index) in partyBAccountList" :key="index" :label="item.bank" :value="item.bank">
                  </el-option>
                </el-select>
              </div>
              <div class="infoItem">
                <label>账户：</label>
                <div class="inputDiv">{{dataInfo.account.account}}</div>
              </div>

              <div class="infoItem" style="margin-top:58px">
                <label style="width:100%">乙方：{{dataInfo.account.name}}</label>
              </div>
              <div class="infoItem">
                <label>签字盖章：</label>
              </div>
              <div class="infoItem">
                <label>联系人：</label>
                <div class="inputDiv" v-if="editFlag">{{dataInfo.account.party_b_contact}}</div>
                <el-input class="input" v-else v-model="dataInfo.account.party_b_contact" size='mini' placeholder="请输入联系人"></el-input>
              </div>
              <div class="infoItem">
                <label>联系电话：</label>
                <div class="inputDiv" v-if="editFlag">{{dataInfo.account.party_b_phone}}</div>
                <el-input class="input" v-else v-model="dataInfo.account.party_b_phone" size='mini' placeholder="请输入联系电话"></el-input>
              </div>
              <div class="infoItem">
                <label>日期：</label>
                <div class="inputDiv" v-if="editFlag">{{dataInfo.account.add_date}}</div>
                <el-date-picker v-else style="width:160px" v-model="add_date" type="date" size="mini" value-format="yyyy-MM-dd" placeholder="日期">
                </el-date-picker>
              </div>
            </div>
          </div>
        </div>
        <div class="verify_opinion btns-wrap" v-if="!dataInfo.account.verify_status || dataInfo.account.verify_status == 0 || (dataInfo.account.verify_status == 3 || dataInfo.account.verify_status == 5)">
          <add-file @file='(val)=>{uploadFile=val}' :fileOtherList='fileList' :uploadOtherFile='uploadFile'></add-file>
          <div v-if="isAllowExport" class="export-wrap">
            <el-button size="small" type="primary" @click="onClickExport">导出结算单明细</el-button>
            <p class="tips">结算单需要先生成序列号后才可以导出</p>
          </div>
        </div>
        <div class="verify_opinion" v-if="statement_id&&dataInfo.account&&dataInfo.account.files&&dataInfo.account.files.length>0">
          <label style="vertical-align: top;">附件</label>
          <div v-if="uploadFile.length!=0" style="display:inline-block">
            <div v-for="(item,index) in uploadFile" :key="index">
              <div class="enclosure" @click="lookFile(item)">
                <i class="el-icon-search"></i>
                <span>{{item&&item.split('/')&&item.split('/')[item.split('/').length-1]?item.split('/')[item.split('/').length-1]:'附件'}}</span>
              </div>
              <div class="enclosure" @click="downLoadFiles(item)">
                <i class="el-icon-download"></i>
                <span>下载附件</span>
              </div>
            </div>
          </div>
        </div>

        <div class="verify_opinion">
          <div class="item" style="line-height: 20px;">
            <label>经手人备注：</label>
            <span v-if="editFlag" style="color:#5E5F6B;font-size:14px;">{{ dataInfo.account.handler_remark || '-' }}</span>
            <el-input v-else class="textarea" type="textarea" placeholder="请输入" v-model="dataInfo.account.handler_remark" />
          </div>
        </div>

        <div class="verify_opinion">
          <div class="item" v-if="dataInfo.account.verify_status&&dataInfo.account.verify_status!=1">
            <div style="margin:5px 0">
              <label>商务审核人：</label>
              <span style="color:#5E5F6B;font-size:14px;">{{dataInfo.account.verify_user}}</span>
            </div>
            <div style="margin:5px 0">
              <label>商务审核时间：</label>
              <span style="color:#5E5F6B;font-size:14px;">{{dataInfo.account.verify_time}}</span>
            </div>
            <div style="margin:5px 0">
              <label>商务审核备注：</label>
              <span style="font-size:14px;" :style="dataInfo.account.verify_status == 3 ? 'color:#d51313':'color:#5E5F6B'">{{dataInfo.account.verify_opinion}}</span>
            </div>
          </div>
        </div>
        <div class="verify_opinion" v-if="dataInfo.account.verify_status==4||dataInfo.account.verify_status==5">
          <div style="margin:5px 0">
            <label>财务审核人：</label>
            <span style="color:#5E5F6B;font-size:14px;">{{dataInfo.account.confirm_verify_user}}</span>
          </div>
          <div style="margin:5px 0">
            <label>财务审核时间：</label>
            <span style="color:#5E5F6B;font-size:14px;">{{dataInfo.account.confirm_verify_time}}</span>
          </div>
          <div style="margin:5px 0">
            <label>财务审核备注：</label>
            <span style="font-size:14px;" :style="dataInfo.account.verify_status == 5 ? 'color:#d51313':'color:#5E5F6B;'">{{dataInfo.account.confirm_verify_opinion}}</span>
          </div>
        </div>
        <div slot="footer" style="text-align: center;margin-top:40px">
          <template v-if="dataInfo.account.is_voided!=1">
            <el-button type="primary" size='small' @click="editStatement({status:0})" v-if="dataInfo.account.verify_status == 0 || dataInfo.account.verify_status == 3 || dataInfo.account.verify_status == 5 || !statement_id">保 存</el-button>
          </template>
          <el-button type="primary" size='small' @click="editStatement({status:1})" v-if="dataInfo.account.verify_status == 0 || dataInfo.account.verify_status == 3 || dataInfo.account.verify_status == 5 || !statement_id">{{enable_apply==1?'重新申请':'提 交'}}</el-button>
        </div>
      </div>
    </div>
    <!-- 导出文件 -->
    <export-tem :dataInfo='dataInfo' :type='type' v-if="exportFlag" @exportSuccess='exportFlag=false;'></export-tem>
    <!-- 查看文件  -->
    <!-- <look-file v-if="lookFlag" :fileUrl = 'file_url' @close="()=>{lookFlag=false}"></look-file> -->
  </div>
</template>
<script>
import addFile from '@/components/assembly/addFile'
import gameStatement from '../examine/gameStatement.vue';
import cpaStatement from '../examine/cpaStatement.vue';
import mcnStatement from './mcnStatementDetail.vue'
import pddStatement from '../examine/pddStatement.vue'
import exportTem from './exportTem.vue'
import { getCookie,delAllCookie } from '@/assets/js/cookie.js'

export default {
  components: { gameStatement, cpaStatement, mcnStatement, pddStatement, exportTem, addFile },
  data () {
    return {
      loading: false,
      type: '',
      dataInfo: {},
      add_date: '',
      party_a_add_date: '',
      discountFlag: 0,
      fileList: [],
      uploadFile: [],
      // lookFlag:false,
      file_url: '',
      statement_id: '',
      partyBAccountList: [],
      editFlag: false,
      exportFlag: false,
      enable_apply: 0,
      editStataus: false,
      // mcnStatementRef: ref()
    }
  },
  computed: {
    isAllowExport() { // 允许被导出结算单明细的类型
      return [4, 5, 6].includes(Number(this.type))
    },
  },
  created () {
    this.enable_apply = this.$route.query.enable_apply == 1 ? 1 : 0
    this.discountFlag = this.$route.query.discountFlag == 1 ? 1 : 0
    this.type = this.$route.params.type;
    this.statement_id = this.$route.query.id;
    if (this.statement_id) {
      if (this.enable_apply == 1) {
        this.statements_reApply()
      } else {
        this.statementsDetail()
      }
    } else {
      var date = new Date();
      this.party_a_add_date = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
      this.add_date = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
      this.dataInfo = localStorage.getItem('statementsAddInfo' + this.$route.query.localName) ? JSON.parse(localStorage.getItem('statementsAddInfo' + this.$route.query.localName)) : {};
      this.getPartyBAccountList()
      this.editFlag = this.dataInfo.account.verify_status != 0 && (this.dataInfo.account.verify_status != 3 && this.dataInfo.account.verify_status != 5) && this.statement_id ? true : false;
    }
  },
  methods: {
    downLoadFiles (data) {//下载
      var url = data.replace("http://", window.location.protocol + '//');
      var doc_name = (url.split('/'))[url.split('/').length - 1]
      this.ajax(url, (xhr) => {
        this.downloadFile(xhr.response, doc_name)
      }, {
        responseType: 'blob'
      })
    },
    ajax (url, callback, options) {
      window.URL = window.URL || window.webkitURL
      var xhr = new XMLHttpRequest()
      xhr.open('get', url, true)
      if (options.responseType) {
        xhr.responseType = options.responseType
      }
      xhr.onreadystatechange = function () {
        if (xhr.readyState === 4 && xhr.status === 200) {
          callback(xhr)
        }
      }
      xhr.send()
    },
    downloadFile (content, filename) {
      var a = document.createElement('a')
      var blob = new Blob([content])
      var url = window.URL.createObjectURL(blob)
      a.href = url
      a.download = filename
      a.click()
      window.URL.revokeObjectURL(url)
    },
    lookFile (data) {//查看文件
      this.file_url = data;
      // this.lookFlag = true
      let routeData = this.$router.resolve({
        path: '/lookFile?url=' + this.file_url,
      })
      this.$winopen(routeData.href)
    },
    print_png_DOM () {
      this.editFlag = true;
      this.$nextTick(() => {
        this.getPdf({
          title: this.type == 2 ? 'MCN机构服务费结算单' : this.dataInfo.account.party_a_name + '结算单', noScrollBar: false, invoice: true, cb: () => {
            this.editFlag = false
          }
        })
      })
    },
    printDOM () {
      this.$loading(this.$loadingConfig);
      this.exportFlag = true;
      return
      this.editFlag = true;
      this.$nextTick(() => {
        this.getPdf({
          title: this.type == 2 ? 'MCN机构服务费结算单' : this.dataInfo.account.party_a_name + '结算单', cb: () => {
            this.editFlag = false
          }
        })
      })
      // document.title = '新媒体事业部消耗表系统'
      // this.$print(this.$refs.printStatement2)
    },
    statements_reApply () {//作废重新申请详情
      this.loading = true;
      this.$axios.post(this.URL.BASEURL + this.URL.statements_reApply, {
        id: this.statement_id
      }).then((res) => {
        var res = res.data;
        this.loading = false;
        if (res && res.errno == 0) {
          this.dataInfo = res.rst;
          this.discountFlag = this.dataInfo.account.is_discount;
          var date = new Date();
          this.party_a_add_date = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
          this.add_date = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
          this.getPartyBAccountList()

          this.editFlag = this.dataInfo.account.verify_status && this.dataInfo.account.verify_status != 0 && (this.dataInfo.account.verify_status != 3 && this.dataInfo.account.verify_status != 5) && this.statement_id ? true : false;
          this.uploadFile = this.dataInfo.account.files ? this.dataInfo.account.files : []
          this.fileList = [];
          if (this.dataInfo.account.files) {
            this.dataInfo.account.files.forEach((item, index) => {
              this.fileList.push({ name: item && item.split('/') && item.split('/')[item.split('/').length - 1] ? item.split('/')[item.split('/').length - 1] : '附件', url: item })
            });
          }
        } else {
          this.$message({
            message: res.err,
            type: 'warning'
          })
        }
      }).catch(() => {
        this.loading = false
      })
    },
    statementsDetail () {
      this.loading = true;
      this.$axios.get(this.URL.BASEURL + this.URL.statementsDetail, {
        params: {
          id: this.statement_id
        }
      }).then((res) => {
        var res = res.data;
        this.loading = false;
        if (res && res.errno == 0) {
          this.dataInfo = res.rst;
          this.discountFlag = this.dataInfo.account.is_discount;
          this.party_a_add_date = this.dataInfo.account.party_a_add_date;
          this.add_date = this.dataInfo.account.add_date;
          this.getPartyBAccountList()

          this.editFlag = this.dataInfo.account.verify_status != 0 && (this.dataInfo.account.verify_status != 3 && this.dataInfo.account.verify_status != 5) && this.statement_id ? true : false;

          this.uploadFile = this.dataInfo.account.files ? this.dataInfo.account.files : []
          this.fileList = [];
          if (this.dataInfo.account.files) {
            this.dataInfo.account.files.forEach((item, index) => {
              this.fileList.push({ name: item && item.split('/') && item.split('/')[item.split('/').length - 1] ? item.split('/')[item.split('/').length - 1] : '附件', url: item })
            });
          }
        } else {
          this.$message({
            message: res.err,
            type: 'warning'
          })
        }
      }).catch(() => {
        this.loading = false
      })
    },
    editStatement ({ status }) {//提交
      var order_data = [];
      this.dataInfo.order.list.forEach((items) => {
        items.row.forEach((item) => {
          order_data.push(item)
        })
      })
      if (order_data.length == 0) {
        this.$message({
          message: '请提交订单信息',
          type: 'warning'
        })
        return;
      }
      if (!this.dataInfo.account.party_a_ein || this.dataInfo.account.party_a_ein == '') {
        this.$message({
          message: '请输入甲方税号',
          type: 'warning'
        })
        return;
      }
      if (!this.dataInfo.account.party_a_account || this.dataInfo.account.party_a_account == '') {
        this.$message({
          message: '请输入甲方银行/账号',
          type: 'warning'
        })
        return;
      }
      if (!this.dataInfo.account.party_a_contact || this.dataInfo.account.party_a_contact == '') {
        this.$message({
          message: '请输入甲方联系人',
          type: 'warning'
        })
        return;
      }
      if (this.dataInfo.account.party_a_phone == '') {
        // if(!(/^1[3456789]\d{9}$/.test(this.dataInfo.account.party_a_phone))){
        this.$message({
          message: '请输入正确的甲方联系方式',
          type: 'warning'
        })
        return false;
      }
      if (!this.dataInfo.account.party_a_address || this.dataInfo.account.party_a_address == '') {
        this.$message({
          message: '请输入甲方地址/电话',
          type: 'warning'
        })
        return;
      }
      if (!this.dataInfo.account.party_b_contact || this.dataInfo.account.party_b_contact == '') {
        this.$message({
          message: '请输入乙方联系人',
          type: 'warning'
        })
        return;
      }
      // if(!(/^1[3456789]\d{9}$/.test(this.dataInfo.account.party_b_phone))){
      if (this.dataInfo.account.party_b_phone == '') {
        this.$message({
          message: '请输入正确的乙方联系方式',
          type: 'warning'
        })
        return false;
      }
      if (!this.add_date || this.add_date == '') {
        this.$message({
          message: '请选择乙方日期',
          type: 'warning'
        })
        return;
      }
      if (!this.party_a_add_date || this.party_a_add_date == '') {
        this.$message({
          message: '请选择甲方日期',
          type: 'warning'
        })
        return;
      }

      this.loading = true;
      var axios_api = this.URL.statementsAdd;
      if (this.enable_apply != 1 && (this.dataInfo.account.verify_status == 0 || this.dataInfo.account.verify_status == 3 || this.dataInfo.account.verify_status == 5) && this.statement_id) {//编辑
        axios_api = this.URL.statementsUpdate;
      }
      var params = {
        id: this.statement_id ? this.statement_id : '',
        order_data: order_data,
        type: this.type,
        party_a_ein: this.dataInfo.account.party_a_ein,
        party_a_account: this.dataInfo.account.party_a_account,
        party_a_contact: this.dataInfo.account.party_a_contact,
        party_a_phone: this.dataInfo.account.party_a_phone,
        party_a_address: this.dataInfo.account.party_a_address,
        party_b_contact: this.dataInfo.account.party_b_contact,
        party_b_phone: this.dataInfo.account.party_b_phone,
        customer_name: this.dataInfo.account.party_a_name,
        add_date: this.add_date,
        party_a_add_date: this.party_a_add_date,
        is_pdd: this.dataInfo.account.is_pdd,
        files: this.uploadFile,
        status: status,
        is_discount: this.discountFlag,
        company: this.dataInfo.account.company ? this.dataInfo.account.company : '',
        bank: this.dataInfo.account.bank,
        account: this.dataInfo.account.account,
        handler_remark: this.dataInfo.account.handler_remark, // 新增"经手人备注"
      }
      if (this.enable_apply == 1) {
        params.voided_id = this.statement_id
      }
      this.$axios.post(this.URL.BASEURL + axios_api, params).then((res) => {
        var res = res.data;
        this.loading = false;
        if (res && res.errno == 0) {
          if (this.type == 2) {
            if (this.statement_id) {
              this.$router.push({ path: '/myStatementApply' })
            } else {
              this.$router.push({ path: '/mcnStatement' })
            }
          } else {
            if (this.statement_id) {
              this.$router.push({ path: '/myStatementApply' })
            } else {
              this.$router.push({ path: '/incomeStatement' })
            }
          }
          this.$message({
            message: '提交成功',
            type: 'success'
          })
        } else {
          this.$message({
            message: res.err,
            type: 'warning'
          })
        }
      }).catch(() => {
        this.loading = false
      })
    },
    getPartyBAccountList () {
      this.$axios.get(this.URL.BASEURL + this.URL.partyBAccountList, {
        params: {
          page: 1,
          pagesize: 1000,
          name: this.dataInfo.account.company
        }
      }).then((res) => {
        var res = res.data;
        if (res && res.errno == 0) {
          this.partyBAccountList = res.rst.data;
        } else {
          this.$message({
            message: res.err,
            type: 'warning'
          })
        }
      }).catch(() => {
      })
    },
    onClickExport() {
      if (!this.isAllowExport) return this.$message.warning('当前结算单类型暂不可导出')
      if(!this.statement_id) return this.$message.warning('结算单需要先生成序列号后才可以导出')
      this.loading = true;
      this.$axios.get(this.URL.BASEURL + this.URL.statementsExport, {
        params: {
          id: this.statement_id
        },
      }).then((res) => {
        this.loading = false
        if (res.data.errno == 0) {
          window.open(res.data.rst, "_blank")
        } else {
          this.$message.warning(res.data.err)
        }
      }).catch((err) => {
        this.loading = false
      })
    },
    openBatchEditDialog() {
      this.$refs['mcnStatementRef'].openBatchEditDialog()
    }
  }
}
</script>
<style lang="scss" scoped>
@import "./statementDetail.scss";
.btns-wrap {
  display: flex;
  .export-wrap {
    margin-left: 20px;
    .tips {
      font-size: 12px;
      color: #606266;
      margin-top: 7px;
    }
  }
}

</style>
<style lang="scss">
.statementToast {
  .el-form-item__content {
    font-size: 12px !important;
  }
  .el-form-item--mini.el-form-item {
    margin-bottom: 0 !important;
  }
  .table .el-input__inner {
    padding: 0 !important;
    text-align: center !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/newBilling/statementTemplate/template.vue